/**
 * Where the access token lives.
 *
 * Deliberately a module-level holder rather than localStorage: the token is a
 * 15-minute credential and keeping it in memory means a successful XSS cannot
 * lift a long-lived secret out of storage. The refresh token is an HttpOnly
 * cookie the browser manages and JavaScript never sees.
 *
 * @milliswift/auth owns writing to this; the axios interceptors own reading.
 */

let accessToken: string | null = null

let unauthorizedHandler: (() => void) | null = null

export function getAccessToken(): string | null {
  return accessToken
}

export function setAccessToken(token: string | null): void {
  accessToken = token
}

export function clearAccessToken(): void {
  accessToken = null
}

/**
 * Called when a request is rejected and refreshing could not recover the
 * session — the app should clear its state and send the user to sign in.
 */
export function setUnauthorizedHandler(handler: (() => void) | null): void {
  unauthorizedHandler = handler
}

export function notifyUnauthorized(): void {
  unauthorizedHandler?.()
}
